import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import MyHeader from './header';

const Profile = ({ cartItems, cartList, showCartDropdown, onCartToggle, onRemoveItem }) => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState({
    name: '',
    username: '',
    address: '',
    tel1: '',
    tel2: '',
  });
  const [showModal, setShowModal] = useState(false);
  const [orders, setOrders] = useState([]);
  const [loadingOrders, setLoadingOrders] = useState(false);
  const [errorOrders, setErrorOrders] = useState('');
  const [passwordData, setPasswordData] = useState({
    oldPassword: '',
    newPassword: '',
    confirmNewPassword: '',
  });
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchProfile = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        navigate('/login');
        return;
      }
      try {
        const res = await fetch('/profile', {
          headers: {
            'Authorization': 'Bearer ' + token,
          },
        });
        if (res.ok) {
          const data = await res.json();
          setUserData({
            name: data.name || '',
            username: data.username || '',
            address: data.address || '',
            tel1: data.tel1 || '',
            tel2: data.tel2 || '',
          });
          setLoading(false);
        } else {
          if (res.status === 401) {
            navigate('/login');
          } else {
            setError('Failed to fetch profile data');
            setLoading(false);
          }
        }
      } catch (err) {
        setError('Failed to fetch profile data');
        setLoading(false);
      }
    };
    fetchProfile();
  }, [navigate]);

  const handleChange = (e) => {
    setUserData({ ...userData, [e.target.name]: e.target.value });
  };

  const handlePasswordChange = (e) => {
    setPasswordData({ ...passwordData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
      return;
    }
    try {
      const res = await fetch('/profile', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token,
        },
        body: JSON.stringify(userData),
      });
      if (res.ok) {
        setMessage('Profile updated successfully');
      } else {
        const data = await res.json();
        setError(data.message || 'Failed to update profile');
      }
    } catch (err) {
      setError('Failed to update profile');
    }
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    if (passwordData.newPassword !== passwordData.confirmNewPassword) {
      setError('New passwords do not match');
      return;
    }
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
      return;
    }
    try {
      const res = await fetch('/profile/password', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token,
        },
        body: JSON.stringify({
          oldPassword: passwordData.oldPassword,
          newPassword: passwordData.newPassword,
        }),
      });
      if (res.ok) {
        setMessage('Password changed successfully');
        setPasswordData({
          oldPassword: '',
          newPassword: '',
          confirmNewPassword: '',
        });
      } else {
        const data = await res.json();
        setError(data.message || 'Failed to change password');
      }
    } catch (err) {
      setError('Failed to change password');
    }
  };

  const handleMyOrders = async () => {
    setLoadingOrders(true);
    setErrorOrders('');
    const client_id = userData.username;
    if (!client_id) {
      setErrorOrders('Username not available');
      setLoadingOrders(false);
      return;
    }
    try {
      const res = await fetch(`/myorders/${client_id}`);
      if (res.ok) {
        const data = await res.json();
        setOrders(data);
        setShowModal(true);
      } else {
        setErrorOrders('Failed to fetch orders');
      }
    } catch (err) {
      setErrorOrders('Failed to fetch orders');
    }
    setLoadingOrders(false);
  };

  if (loading) {
    return <div style={{ textAlign: 'center', marginTop: '50px' }}>Loading profile...</div>;
  }

  return (
    <>
      <MyHeader 
        cartItems={cartItems} 
        cartList={cartList} 
        showCartDropdown={showCartDropdown} 
        onCartToggle={onCartToggle} 
        onRemoveItem={onRemoveItem} 
      />

      <br/>      <br/>
      <br/>      <br/>
      <br/>
      <br/>      <br/>
      <br/>      <br/>
      <br/>

      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <button
          onClick={handleMyOrders}
          disabled={loadingOrders}
          style={{
            padding: '12px 24px',
            borderRadius: '10px',
            border: 'none',
            backgroundColor: '#bd3965ff',
            color: 'white',
            fontWeight: '700',
            fontSize: '1.1rem',
            cursor: loadingOrders ? 'not-allowed' : 'pointer',
            transition: 'background-color 0.3s ease'
          }}
          onMouseEnter={e => !loadingOrders && (e.currentTarget.style.backgroundColor = '#a3001a')}
          onMouseLeave={e => !loadingOrders && (e.currentTarget.style.backgroundColor = '#D10024')}
        >
          {loadingOrders ? 'Loading...' : 'My Orders'}
        </button>
        {errorOrders && <p style={{ color: 'red', marginTop: '10px' }}>{errorOrders}</p>}
      </div>

      <div style={{ maxWidth: '600px', margin: '40px auto', padding: '20px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', borderRadius: '12px', backgroundColor: '#fff' }}>
        <h2 style={{ textAlign: 'center', marginBottom: '20px', fontWeight: '700', fontSize: '2rem', color: '#333' }}>Profile</h2>
        {message && <div style={{ backgroundColor: '#d4edda', color: '#155724', padding: '10px 15px', borderRadius: '8px', marginBottom: '15px', textAlign: 'center' }}>{message}</div>}
        {error && <div style={{ backgroundColor: '#f8d7da', color: '#721c24', padding: '10px 15px', borderRadius: '8px', marginBottom: '15px', textAlign: 'center' }}>{error}</div>}

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginBottom: '40px' }}>
          <label style={{ display: 'flex', flexDirection: 'column', fontWeight: '600', color: '#555' }}>
            Name:
            <input 
              type="text" 
              name="name" 
              value={userData.name} 
              onChange={handleChange} 
              required 
              style={{ padding: '10px', borderRadius: '8px', border: '1px solid #ccc', fontSize: '1rem', marginTop: '5px' }}
            />
          </label>
          <label style={{ display: 'flex', flexDirection: 'column', fontWeight: '600', color: '#555' }}>
            Address:
            <input 
              type="text" 
              name="address" 
              value={userData.address} 
              onChange={handleChange} 
              style={{ padding: '10px', borderRadius: '8px', border: '1px solid #ccc', fontSize: '1rem', marginTop: '5px' }}
            />
          </label>
          <label style={{ display: 'flex', flexDirection: 'column', fontWeight: '600', color: '#555' }}>
            Telephone 1:
            <input 
              type="text" 
              name="tel1" 
              value={userData.tel1} 
              onChange={handleChange} 
              style={{ padding: '10px', borderRadius: '8px', border: '1px solid #ccc', fontSize: '1rem', marginTop: '5px' }}
            />
          </label>
          <label style={{ display: 'flex', flexDirection: 'column', fontWeight: '600', color: '#555' }}>
            Telephone 2:
            <input 
              type="text" 
              name="tel2" 
              value={userData.tel2} 
              onChange={handleChange} 
              style={{ padding: '10px', borderRadius: '8px', border: '1px solid #ccc', fontSize: '1rem', marginTop: '5px' }}
            />
          </label>
          <button 
            type="submit" 
            style={{ 
              padding: '12px', 
              borderRadius: '10px', 
              border: 'none', 
              backgroundColor: '#9d3256ff', 
              color: 'white', 
              fontWeight: '700', 
              fontSize: '1.1rem', 
              cursor: 'pointer', 
              transition: 'background-color 0.3s ease' 
            }}
            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#bb4b71ff'}
            onMouseLeave={e => e.currentTarget.style.backgroundColor = '#bb4b71ff'}
          >
            Update Profile
          </button>
        </form>

        <h3 style={{ fontWeight: '700', fontSize: '1.5rem', color: '#333', marginBottom: '20px' }}>Change Password</h3>
        <form onSubmit={handlePasswordSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
          <label style={{ display: 'flex', flexDirection: 'column', fontWeight: '600', color: '#555' }}>
            Old Password:
            <input 
              type="password" 
              name="oldPassword" 
              value={passwordData.oldPassword} 
              onChange={handlePasswordChange} 
              required 
              style={{ padding: '10px', borderRadius: '8px', border: '1px solid #ccc', fontSize: '1rem', marginTop: '5px' }}
            />
          </label>
          <label style={{ display: 'flex', flexDirection: 'column', fontWeight: '600', color: '#555' }}>
            New Password:
            <input 
              type="password" 
              name="newPassword" 
              value={passwordData.newPassword} 
              onChange={handlePasswordChange} 
              required 
              style={{ padding: '10px', borderRadius: '8px', border: '1px solid #ccc', fontSize: '1rem', marginTop: '5px' }}
            />
          </label>
          <label style={{ display: 'flex', flexDirection: 'column', fontWeight: '600', color: '#555' }}>
            Confirm New Password:
            <input 
              type="password" 
              name="confirmNewPassword" 
              value={passwordData.confirmNewPassword} 
              onChange={handlePasswordChange} 
              required 
              style={{ padding: '10px', borderRadius: '8px', border: '1px solid #ccc', fontSize: '1rem', marginTop: '5px' }}
            />
          </label>
          <button 
            type="submit" 
            style={{ 
              padding: '12px', 
              borderRadius: '10px', 
              border: 'none', 
              backgroundColor: '#a9395fff', 
              color: 'white', 
              fontWeight: '700', 
              fontSize: '1.1rem', 
              cursor: 'pointer', 
              transition: 'background-color 0.3s ease' 
            }}
            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#a3001a'}
            onMouseLeave={e => e.currentTarget.style.backgroundColor = '#D10024'}
          >
            Change Password
          </button>
        </form>
      </div>

      {showModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: '#fff',
            padding: '20px',
            borderRadius: '12px',
            maxWidth: '800px',
            width: '90%',
            maxHeight: '80%',
            overflowY: 'auto'
          }}>

 <button
              onClick={() => setShowModal(false)}
              style={{
                display: 'block',
                margin: '20px auto 0',
                padding: '10px 20px',
                borderRadius: '8px',
                border: 'none',
                backgroundColor: '#a63a5eff',
                color: 'white',
                cursor: 'pointer'
              }}
            >
              Close
            </button>

            <h3 style={{ textAlign: 'center', marginBottom: '20px' }}>My Orders</h3>
            {orders.length === 0 ? (
              <p style={{ textAlign: 'center' }}>No orders found.</p>
            ) : (
              <div>
                {Object.entries(orders.reduce((acc, order) => {
                  if (!acc[order.order_id]) acc[order.order_id] = [];
                  acc[order.order_id].push(order);
                  return acc;
                }, {})).map(([orderId, items]) => (
                  <div key={orderId} style={{
                    border: '1px solid #ccc',
                    borderRadius: '8px',
                    padding: '10px',
                    marginBottom: '10px'
                  }}>
                    <p><strong>Order ID:</strong> {orderId}</p>
                    {items.map((item, idx) => (
                      <p key={idx}><strong>Item:</strong> {item.item_name} / <strong>Qt:</strong> {item.quantity} / <strong>Total Price:</strong> {item.total_price} $</p>
                    ))}
                    <p><strong>Order Total:</strong> {items.reduce((sum, item) => sum + parseFloat(item.total_price), 0).toFixed(2)} $</p>
                  </div>
                ))}
              </div>
            )}
           
          </div>
        </div>
      )}
    </>
  );
};

export default Profile;
